import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import {observer} from 'mobx-react'
import strings from '../../lang/strings'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {MenuMy} from '../../config/page_route'
import {rootStore} from '../../mobx/store'
import {formatNumber} from '../../helper/common'
import CouponRegisterModal from '../../components/control/modal/modal_coupon_register'

const MoMyPage = observer((props) => {
  const context = useContext(Page_settings)

  let [dropBj, setDropbj] = useState(false)
  let [dropAnalyst, setDropAnalyst] = useState(false)
  let [showCouponModal, setShowCouponModal] = useState(false)

  useEffect(() => {
    context.getPoint()
  }, [])

  const onclick = (e, item) => {
    if (!item.path) {
      e.preventDefault()
      if (item.logout) context.showLogout()
      if (item.signout) context.showSignout()
    }
  }

  const onCouponRegister = () => {
    setShowCouponModal(false)
  }

  const onPointPay = () => {
    context.showPointPay(() => {})
  }

  const onBJ = (bj) => {
    context.post('data/bj_list', {bj_id: bj.mb_id},
      response => {
        const mb = response.bj
        if (mb != null) props.history.push(`/bj/detail/${mb.mb_id}`, { bjList: response.bj_list })
      }
    )
  }

  const onWinee = (winee) => {
    context.post( 'data/an_list', {an_id: winee.mb_id},
      response => {
        const mb = response.an
        if (mb != null) props.history.push('/analyst/detail', { info: mb, wineeList: response.winee_list })
      }
    )
  }

  return (
    <React.Fragment>
      <div className='sidebar_login'>
        <div className='d-center'>
          <div className='flex-full fs-18 f-m color-3a3335'><u className='f-b'>{rootStore.getMe.mb_nick}</u> {strings.nim}</div>
          <div className='flex-full d-flex align-items-center justify-content-end'>
            <div className='color-4c4c4d fs-14 f-m'>{strings.point}</div>
            <div className='color-0a3962 fs-18 f-b ml-4'>{formatNumber(rootStore.getMe.mb_point)}p</div>
          </div>
        </div>
        <div className='d-flex mt-20 fs-14 f-sb'>
          <a className='btn btn-white flex-full hx-48 d-center border-e4e9f2' onClick={onPointPay}>{strings.po_charge}</a>
          <a className='btn btn-white flex-full hx-48 d-center border-e4e9f2 ml-8' onClick={() => {setShowCouponModal(true)}}>{strings.coupon_register}</a>
        </div>
      </div>
      <div className='divider1'/>
      <div className='d-center cursor-point fav-bj' onClick={() => setDropbj(!dropBj)}>
        <img className='like_on' src={'/assets/image/like_on.png'} alt=''/>
        <div className='flex-full color-3a3335 fs-14 f-b ml-4'>{strings.fav_bj}</div>
        <img className='a5_d' src={dropBj ? '/assets/image/a5_u.png' : '/assets/image/a5_d.png'} alt=''/>
      </div>
      {dropBj &&
      <PerfectScrollbar className='dropdown-fav-item' options={{suppressScrollX: true}}>
        {rootStore.getFavBj &&
        rootStore.getFavBj.map((item, index) => {
          return (
            <a className='d-flex align-items-center w-100 hover-underline pt-7 pb-7' key={index} onClick={() => {onBJ(item)}}>
              <div className='fs-15 color-3a3335 f-m text-line'>{item.mb_nick} {strings.bj}<span className='fs-12 color-8f8f8f ml-12'>{item.mb_intro}</span></div>
            </a>
          )
        })
        }
      </PerfectScrollbar>
      }
      {/* <div className='d-center cursor-point fav-bj' onClick={() => setDropAnalyst(!dropAnalyst)}>
        <img className='like_on' src={'/assets/image/like_on.png'} alt=''/>
        <div className='flex-full color-3a3335 fs-14 f-b ml-4'>{strings.fav_analyst}</div>
        <img className='a5_d' src={dropAnalyst ? '/assets/image/a5_u.png' : '/assets/image/a5_d.png'} alt=''/>
      </div> */}
      {dropAnalyst &&
      <PerfectScrollbar className='dropdown-fav-item' options={{suppressScrollX: true}}>
        {rootStore.getFavWinee &&
        rootStore.getFavWinee.map((item, index) => {
          return (
            <a className='d-flex align-items-center w-100 hover-underline pt-7 pb-7' key={index} onClick={() => {onWinee(item)}}>
              {/* <div className='fs-15 color-3a3335 f-m text-line'>{item.mb_nick} {strings.member}<span className='fs-12 color-8f8f8f ml-12'>{item.mb_intro1}</span></div> */}
              <div className='fs-15 color-3a3335 f-m text-line'>{strings.member} {item.mb_nick}</div>
            </a>
          )
        })
        }
      </PerfectScrollbar>
      }
      <div className='divider1'/>
      {
        MenuMy.map((item, index) => {
          if (item.bjcheck) {
            if (rootStore.getMe.mb_lv > 1) {
              return (
                <a key={index} href={(item.path) ? item.path : ''} onClick={(e) => onclick(e, item)}
                  className={'d-flex align-items-center sidebar-left-menu'}>
                  <div className='flex-full fs-14 f-m color-4c4c4d'>{item.title}</div>
                </a>
              )
            }
            return null;
          }
          return (
            <a key={index} href={(item.path) ? item.path : ''} onClick={(e) => onclick(e, item)}
               className={'d-flex align-items-center sidebar-left-menu'}>
              <div className='flex-full fs-14 f-m color-4c4c4d'>{item.title}</div>
            </a>
          )
        })
      }
      <CouponRegisterModal show={showCouponModal} toggle={() => {setShowCouponModal(!showCouponModal)}} onConfirm={()=> {onCouponRegister()}}/>
    </React.Fragment>
  )
})

export default withRouter(MoMyPage)
